import axios from "axios";
import Swal from 'sweetalert2'
import { queryClient } from "../../..";

export default async function deleteArquivo(
  Token: string,
  onSuccess: () => void,
) {
  return await axios.delete(Token)
  .then((response : any) => {
    Swal.fire({
      title: "Arquivo Deletado",
      text: "O arquivo foi apagado com sucesso!",
      icon: "success",
      position: "center",
      confirmButtonText: "OK",
      confirmButtonColor: "#349946",
      allowOutsideClick: false
    }).then((response : any) => {
      if (response.isConfirmed) {
        onSuccess();
        queryClient.invalidateQueries();
      }
    })
    return response;
  })
  .catch((err : any) => {
    Swal.fire({
      title: 'Ocorreu um erro',
      text: err.response.data.message,
      icon: 'error',
      position: 'center',
      confirmButtonText: 'Ok',
      confirmButtonColor: '#F27474',
      allowOutsideClick: false
    })
  })
}